import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import SwitchIconButton from "@/components/buttons/SwitchIconButton/SwitchIconButton.vue";
import { useComputedValue } from "@/composables";
import { GetterTypes, MutationTypes } from "@/store";
import { IOngoingCall } from "@/store/auth/types";
import { IconType } from "@/types/icons";
import { useStore } from "vuex";


export default /*#__PURE__*/_defineComponent({
  __name: 'ToggleMicrophoneButton',
  setup(__props) {

const { commit } = useStore();
const hasAudio = useComputedValue<boolean>(
  GetterTypes.GET_ONGOING_CALL_HAS_AUDIO,
);
const currentCall = useComputedValue<IOngoingCall>(
  GetterTypes.GET_CURRENT_ONGOING_CALL,
);

const toggleHasAudio = () => {
  commit(MutationTypes.TOGGLE_ONGOING_CALL_AUDIO, {
    value: !hasAudio.value,
    callId: currentCall.value.chatId,
  });
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(SwitchIconButton, {
    "active-icon": _unref(IconType).CONTROL_MICROPHONE_ACTIVE,
    "inactive-icon": _unref(IconType).CONTROL_MICROPHONE_INACTIVE,
    "is-active": _unref(hasAudio),
    onClick: toggleHasAudio
  }, null, 8, ["active-icon", "inactive-icon", "is-active"]))
}
}

})